import React, { useContext, useEffect } from "react";
import { Logout } from "@mui/icons-material";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";
import { AuthContext } from "../../context/AuthContext";
import "./navbar.module.scss"

export default function Navbar() {
  const { currentUser } = useContext(AuthContext);

  return (
    <div className="navbar">
      <span className="logo">Chatmore</span>
      <div className="navContent">
        <img
          src={
            currentUser.photoURL
              ? currentUser.photoURL
              : "https://cdn-icons-png.flaticon.com/128/2202/2202112.png"
          }
          alt=""
        />
        <span className="username">{currentUser.displayName}</span>
        <button className="logoutBtnText" onClick={() => signOut(auth)}>
          <span >logout</span>
          <Logout className="icon" />
        </button>
      </div>
    </div>
  );
}
